import { getDiffVal } from "utils/index"
function mixin() {
  return {
    props: {
      defaultValue: undefined,
      config: undefined
    },
    computed: {
      configData: {
        get() {
          const self = this
          if (Array.isArray(this.defaultValue)) {
            return this.config || this.defaultValue  
          }
          if (Object.prototype.toString.call(this.defaultValue) === '[object Object]') {
            const originValue = Object.assign({}, this.defaultValue || {}, this.config)
            return new Proxy(
              originValue,
              {
                get(target, key) {
                  return originValue[key]
                },
                set(target, key, newVal) {
                  const submitVal = getDiffVal({ ...originValue, [key]: newVal }, self.defaultValue)
                  self.$emit("update:config", submitVal)
                  return true
                }
              }
            )
          }
          return this.config || this.defaultValue   
        },
        set(newVal) {
          const submitVal = getDiffVal(newVal, this.defaultValue)
          this.$emit("update:config", submitVal)
        }
      }
    }
  }
}
export default mixin
